import { chain } from "lodash"
import { SelectedBenchmark } from "helpers/types/instruments/selected"
import { IsoDate } from "helpers/types/dates"
import { OkReduxDataResult } from "model/state"
import { LONG } from "./composition"
import { PositionSetMetadata } from "./types"

interface BenchmarksData {
  model: {
    benchmarks: {
      id: string
      name: string
      availableFrom: IsoDate
      currentDate: IsoDate
    }[]
  }
}

export interface BenchmarkMetadata extends PositionSetMetadata {
  type: "BENCHMARK"
}

// [TODO] single benchmark
const BENCHMARKS_QUERY = `query ($modelId: String!) {
  model (id: $modelId) {
    benchmarks {
      id
      name
      availableFrom
      currentDate
    }
  }
}`

function benchmarkSelect(data: OkReduxDataResult<BenchmarksData>, positionSet: SelectedBenchmark): BenchmarkMetadata {
  return chain(data)
    .get("data.model.benchmarks")
    .find(b => b.id === positionSet.id)
    .thru((b): BenchmarkMetadata => {
      if (b) {
        return { type: "BENCHMARK", unavailable: false, name: b.name, compositionType: LONG, earliestDate: b.availableFrom, latestDate: b.currentDate }
      } else {
        // [TODO:TS] We need a better solution
        return { type: "BENCHMARK", unavailable: true, name: undefined } as unknown as BenchmarkMetadata
      }
    })
    .value()
}

export function getBenchmarkQueryDefinition(positionSet: SelectedBenchmark, modelId: string) {
  return {
    query: BENCHMARKS_QUERY,
    variables: { modelId },
    // [HACK]: We need the ID here even if the query is the same for all benchmarks,
    // as the select is different.
    queryKey: ["position-set", "metadata", "benchmarks", modelId, positionSet.id],
    select: (data: OkReduxDataResult<BenchmarksData>) => benchmarkSelect(data, positionSet),
  }
}
